import { twMerge } from "tailwind-merge";

type Props = { className?: string; message?: string | null };

function ErrorMessage({ className = "", message }: Props) {
    if (!message) return null;
    return (
        <div className={twMerge("text-red-500 text-sm", className)}>
            {message}
        </div>
    );
}

export default ErrorMessage;
